import { render } from "./ItemListDocencia.vue?vue&type=template&id=395b8015&scoped=true"
import script from "./ItemListDocencia.vue?vue&type=script&lang=js"
export * from "./ItemListDocencia.vue?vue&type=script&lang=js"

import "./ItemListDocencia.vue?vue&type=style&index=0&id=395b8015&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-395b8015"]])

export default __exports__